import React from 'react';
import { useBooking } from '../../../../contexts/ticketBookingContext/TicketBookingContext';

function BookingStepper() {
  const {
    activeStep,
    steps,
  } = useBooking();

  return (
    <div className="flex gap-4 flex-wrap">
      {steps?.map((step, index) => {
        const isActive = index + 1 <= activeStep;
        const isCurrent = index + 1 === activeStep;
        return (
          <button
            className="flex items-center gap-[10px] border-0 bg-transparent p-0 cursor-pointer"
            type="button"
            key={step}
          >
            <div
              className={`flex font-sans text-base items-center h-[23px] w-[23px] rounded-2xl justify-center ${isActive ? 'bg-primary' : 'bg-gray-gr'} text-white ease-out duration-300`}
            >
              {index + 1}
            </div>
            <p className={`m-0 font-bold text-${isActive ? 'black' : 'gray-gr'} ${isCurrent ? 'block' : 'hidden'} text-base ease-out duration-300 lg:block`}>{step}</p>
            {steps.length > index + 1 && <p className={`${isCurrent ? 'block' : 'hidden'} lg:block flex items-center m-0`}><i className="arrow right" /></p>}
          </button>
        );
      })}
    </div>
  );
}

export default BookingStepper;
